import { BaseView } from '../../../shared/utils/baseComponent'
import template from './new-password.component.pug'
import css from './new-password.component.scss'

class NewPasswordController extends BaseView {
  constructor($element, $cookies, $state, $http, SessionService, $mdToast, $timeout) {
    'ngInject'
    super($element)
    Object.assign(
      this,
      { $cookies, $state, $http, SessionService, $mdToast, $timeout },
      {
        sent: false,
        passwordMinLength: 8,
        cookie: null,
        passwordChangeSuccess: false,
      },
    )
  }

  $onInit() {
    const cookie = this.$cookies.get('umsema')
    if (!cookie) return this.$state.go('password')
    this.cookie = JSON.parse(window.atob(cookie))
    this.onlyResetPassword = this.cookie.appType === 'SCANNER'
  }

  onChangePasswordRepeat() {
    this.newPasswordFrm.passwordRepeat.$setValidity('match', this.password === this.passwordRepeat)
  }

  setNewPassword() {
    const password = this.password
    const email = this.cookie.email

    return this.$http({
      method: 'PATCH',
      url: '/api/users/password',
      data: { password },
    })
      .then(() => {
        if (this.onlyResetPassword) {
          this.$cookies.remove('umsema')
          this.sent = true
        } else {
          return this.SessionService.authenticateByCredentials({ email, password }).then((user) => {
            return this.$state
              .go('customers.customer.tasksites', { customerId: user.customers[0].customer.no })
              .then(() => {
                this.$cookies.remove('umsema')
                this.$timeout(() => {
                  this.$mdToast.show(
                    this.$mdToast
                      .simple()
                      .textContent('Passwort erfolgreich geändert. Sie können ab jetzt Ihr neues Passwort nutzen.')
                      .action('OK')
                      .position('bottom')
                      .hideDelay(10000),
                  )
                }, 300)
              })
              .catch((err) => console.log(err))
          })
        }
      })
      .catch((err) => {
        console.error('err', err)
      })
  }
}

export const newPasswordComponent = {
  controller: NewPasswordController,
  template: template({ css }),
}



// WEBPACK FOOTER //
// ./app/account/containers/new-password/new-password.component.js